/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type PhasesSection_phases$ref = any;
export type DeletePhaseBaselineExpenseInput = {|
  id?: ?string,
  projectId?: ?string,
  csrfToken?: ?string,
  socketClientId?: ?string,
  clientMutationId?: ?string,
|};
export type DeletePhaseBaselineExpenseMutationVariables = {|
  input: DeletePhaseBaselineExpenseInput
|};
export type DeletePhaseBaselineExpenseMutationResponse = {|
  +deletePhaseBaselineExpense: ?{|
    +project: ?{|
      +id: string,
      +baselineTargetMinutes: ?number,
      +baselineTargetPrice: ?number,
      +baselineCost: ?number,
      +baselineProfit: ?number,
      +phases: ?{|
        +edges: ?$ReadOnlyArray<?{|
          +$fragmentRefs: PhasesSection_phases$ref
        |}>
      |},
    |}
  |}
|};
export type DeletePhaseBaselineExpenseMutation = {|
  variables: DeletePhaseBaselineExpenseMutationVariables,
  response: DeletePhaseBaselineExpenseMutationResponse,
|};
*/


/*
mutation DeletePhaseBaselineExpenseMutation(
  $input: DeletePhaseBaselineExpenseInput!
) {
  deletePhaseBaselineExpense(input: $input) {
    project {
      id
      baselineTargetMinutes
      baselineTargetPrice
      baselineCost
      baselineProfit
      phases(first: 100000) {
        edges {
          ...PhasesSection_phases
          cursor
          node {
            __typename
            id
          }
        }
        pageInfo {
          endCursor
          hasNextPage
        }
      }
    }
  }
}

fragment ExpenseRow_phaseBaselineExpense on PhaseBaselineExpenseType {
  id
  phaseId
  expenseCategory {
    id
    name
  }
  expenseCost
  expenseMarkup
  expenseRevenue
  expenseProfit
}

fragment Phase_phase on PhaseType {
  id
  name
  baselineTargetPrice
  baselineTargetMinutes
  baselineCost
  baselineProfit
  startYear
  startMonth
  startDay
  deadlineYear
  deadlineMonth
  deadlineDay
  baselineStartYear
  baselineStartMonth
  baselineStartDay
  baselineDeadlineYear
  baselineDeadlineMonth
  baselineDeadlineDay
  phaseBaselineRoles(first: 100000) {
    edges {
      node {
        id
        ...RoleRow_phaseBaselineRole
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  phaseBaselineExpenses(first: 100000) {
    edges {
      node {
        id
        ...ExpenseRow_phaseBaselineExpense
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment PhasesSection_phases on PhaseTypeEdge {
  node {
    id
    ...Phase_phase
    startYear
    startMonth
    startDay
    deadlineYear
    deadlineMonth
    deadlineDay
  }
}

fragment RoleRow_phaseBaselineRole on PhaseBaselineRoleType {
  id
  phaseId
  role {
    id
    name
  }
  baselineMinutes
  baselinePrice
  baselineRatePerHour
  baselineCost
  baselineCostPerHour
  baselineProfit
  startYear
  startMonth
  startDay
  deadlineYear
  deadlineMonth
  deadlineDay
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeletePhaseBaselineExpenseInput!"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "baselineTargetMinutes",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "baselineTargetPrice",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "baselineCost",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "baselineProfit",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v10 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 100000
  }
],
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startYear",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startMonth",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startDay",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deadlineYear",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deadlineMonth",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deadlineDay",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "phaseId",
  "storageKey": null
},
v19 = [
  (v2/*: any*/),
  (v11/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DeletePhaseBaselineExpenseMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeletePhaseBaselineExpensePayload",
        "kind": "LinkedField",
        "name": "deletePhaseBaselineExpense",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectType",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              {
                "alias": "phases",
                "args": null,
                "concreteType": "PhaseTypeConnection",
                "kind": "LinkedField",
                "name": "__Project_phases_connection",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PhaseTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      (v7/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PhaseType",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v8/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "PhasesSection_phases"
                      }
                    ],
                    "storageKey": null
                  },
                  (v9/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DeletePhaseBaselineExpenseMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeletePhaseBaselineExpensePayload",
        "kind": "LinkedField",
        "name": "deletePhaseBaselineExpense",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectType",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              {
                "alias": null,
                "args": (v10/*: any*/),
                "concreteType": "PhaseTypeConnection",
                "kind": "LinkedField",
                "name": "phases",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PhaseTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PhaseType",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          (v11/*: any*/),
                          (v4/*: any*/),
                          (v3/*: any*/),
                          (v5/*: any*/),
                          (v6/*: any*/),
                          (v12/*: any*/),
                          (v13/*: any*/),
                          (v14/*: any*/),
                          (v15/*: any*/),
                          (v16/*: any*/),
                          (v17/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "baselineStartYear",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "baselineStartMonth",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "baselineStartDay",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "baselineDeadlineYear",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "baselineDeadlineMonth",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "baselineDeadlineDay",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": (v10/*: any*/),
                            "concreteType": "PhaseBaselineRoleTypeConnection",
                            "kind": "LinkedField",
                            "name": "phaseBaselineRoles",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "PhaseBaselineRoleTypeEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "PhaseBaselineRoleType",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v2/*: any*/),
                                      (v18/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Role",
                                        "kind": "LinkedField",
                                        "name": "role",
                                        "plural": false,
                                        "selections": (v19/*: any*/),
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "baselineMinutes",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "baselinePrice",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "baselineRatePerHour",
                                        "storageKey": null
                                      },
                                      (v5/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "baselineCostPerHour",
                                        "storageKey": null
                                      },
                                      (v6/*: any*/),
                                      (v12/*: any*/),
                                      (v13/*: any*/),
                                      (v14/*: any*/),
                                      (v15/*: any*/),
                                      (v16/*: any*/),
                                      (v17/*: any*/),
                                      (v8/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v7/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v9/*: any*/)
                            ],
                            "storageKey": "phaseBaselineRoles(first:100000)"
                          },
                          {
                            "alias": null,
                            "args": (v10/*: any*/),
                            "filters": [],
                            "handle": "connection",
                            "key": "Phase_phaseBaselineRoles",
                            "kind": "LinkedHandle",
                            "name": "phaseBaselineRoles"
                          },
                          {
                            "alias": null,
                            "args": (v10/*: any*/),
                            "concreteType": "PhaseBaselineExpenseTypeConnection",
                            "kind": "LinkedField",
                            "name": "phaseBaselineExpenses",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "PhaseBaselineExpenseTypeEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "PhaseBaselineExpenseType",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v2/*: any*/),
                                      (v18/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ExpenseCategory",
                                        "kind": "LinkedField",
                                        "name": "expenseCategory",
                                        "plural": false,
                                        "selections": (v19/*: any*/),
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "expenseCost",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "expenseMarkup",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "expenseRevenue",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "expenseProfit",
                                        "storageKey": null
                                      },
                                      (v8/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v7/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v9/*: any*/)
                            ],
                            "storageKey": "phaseBaselineExpenses(first:100000)"
                          },
                          {
                            "alias": null,
                            "args": (v10/*: any*/),
                            "filters": [],
                            "handle": "connection",
                            "key": "Phase_phaseBaselineExpenses",
                            "kind": "LinkedHandle",
                            "name": "phaseBaselineExpenses"
                          },
                          (v8/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v7/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v9/*: any*/)
                ],
                "storageKey": "phases(first:100000)"
              },
              {
                "alias": null,
                "args": (v10/*: any*/),
                "filters": [],
                "handle": "connection",
                "key": "Project_phases",
                "kind": "LinkedHandle",
                "name": "phases"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {
      "connection": [
        {
          "count": null,
          "cursor": null,
          "direction": "forward",
          "path": [
            "deletePhaseBaselineExpense",
            "project",
            "phases"
          ]
        }
      ]
    },
    "name": "DeletePhaseBaselineExpenseMutation",
    "operationKind": "mutation",
    "text": "mutation DeletePhaseBaselineExpenseMutation(\n  $input: DeletePhaseBaselineExpenseInput!\n) {\n  deletePhaseBaselineExpense(input: $input) {\n    project {\n      id\n      baselineTargetMinutes\n      baselineTargetPrice\n      baselineCost\n      baselineProfit\n      phases(first: 100000) {\n        edges {\n          ...PhasesSection_phases\n          cursor\n          node {\n            __typename\n            id\n          }\n        }\n        pageInfo {\n          endCursor\n          hasNextPage\n        }\n      }\n    }\n  }\n}\n\nfragment ExpenseRow_phaseBaselineExpense on PhaseBaselineExpenseType {\n  id\n  phaseId\n  expenseCategory {\n    id\n    name\n  }\n  expenseCost\n  expenseMarkup\n  expenseRevenue\n  expenseProfit\n}\n\nfragment Phase_phase on PhaseType {\n  id\n  name\n  baselineTargetPrice\n  baselineTargetMinutes\n  baselineCost\n  baselineProfit\n  startYear\n  startMonth\n  startDay\n  deadlineYear\n  deadlineMonth\n  deadlineDay\n  baselineStartYear\n  baselineStartMonth\n  baselineStartDay\n  baselineDeadlineYear\n  baselineDeadlineMonth\n  baselineDeadlineDay\n  phaseBaselineRoles(first: 100000) {\n    edges {\n      node {\n        id\n        ...RoleRow_phaseBaselineRole\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  phaseBaselineExpenses(first: 100000) {\n    edges {\n      node {\n        id\n        ...ExpenseRow_phaseBaselineExpense\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment PhasesSection_phases on PhaseTypeEdge {\n  node {\n    id\n    ...Phase_phase\n    startYear\n    startMonth\n    startDay\n    deadlineYear\n    deadlineMonth\n    deadlineDay\n  }\n}\n\nfragment RoleRow_phaseBaselineRole on PhaseBaselineRoleType {\n  id\n  phaseId\n  role {\n    id\n    name\n  }\n  baselineMinutes\n  baselinePrice\n  baselineRatePerHour\n  baselineCost\n  baselineCostPerHour\n  baselineProfit\n  startYear\n  startMonth\n  startDay\n  deadlineYear\n  deadlineMonth\n  deadlineDay\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '93ba3243e73c646366c12fee343e55bb';

module.exports = node;
